import React from "react";
import { Info, X } from "lucide-react";
import { useCart } from "../contexts/CartContext";

export default function StockNotes({ className = "" }) {
  const { stockNotes, clearStockNotes } = useCart();
  if (!stockNotes.length) return null;
  return (
    <div className={`bg-[var(--bg-cream)] border border-[var(--terracotta)]/30 rounded-xl p-4 flex gap-3 ${className}`} data-testid="cart-stock-notes">
      <Info className="w-4 h-4 text-[var(--terracotta)] shrink-0 mt-0.5" />
      <div className="flex-1 space-y-1 text-sm text-[var(--ink-forest)]">
        {stockNotes.map((n) => <p key={n}>{n}</p>)}
      </div>
      <button onClick={clearStockNotes} aria-label="Dismiss" className="text-[var(--muted-fg)] hover:text-[var(--ink-forest)]" data-testid="cart-stock-notes-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
